module.exports = __webpack_public_path__ + "images/emoji/sparkler.e8b62f89d684bb541a77.png";